import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer';
import {produce} from 'immer';
import {createSelectors} from '../lib/createStoreSelectors';
import { getAuth, signOut as firebaseSignOut } from 'firebase/auth';

export interface User {
    email: string;
    name: string;
    id?: string;
    photoURL?: string;
    // Add any additional fields that might be returned from Firebase
}
  
type AuthStore = {
  user: User | null;
  setUser: (user: User | null) => void;
  isAuthorized: boolean;
  setIsAuthorized: (isAuthorized: boolean) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  signOut: () => Promise<void>;
}

export const useAuthStoreBase = create<AuthStore>()(
    immer(
        (set) => ({
            user: null,
            setUser: (user: User | null) => {
                set((state) => {state.user = user  })
            },
            isAuthorized: false,
            setIsAuthorized: (isAuthorized: boolean) => {
                set((state) => {state.isAuthorized = isAuthorized  })
            },
            loading: true,
            setLoading: (loading: boolean) => {
                set((state) => {state.loading = loading  })
            },
            signOut: async () => {
                try {
                    set((state) => {state.loading = true  });
                    const auth = getAuth();
                    await firebaseSignOut(auth);
                    set((state) => {state.user = null; state.isAuthorized = false  })
                } catch (error) {
                    console.error('Error signing out:', error);
                    throw error;
                } finally {
                    set((state) => {state.loading = false  });
                }
            }
        })
    )
)

export const useAuthStore = createSelectors(useAuthStoreBase);
